module.exports = __webpack_public_path__ + "img/intro_uk.c04a4792.svg";